import { combineReducers } from 'redux'

// ACTIONS
export const CREATE = 'offerzen/educations/CREATE'
export const CREATE_SUCCESS = 'offerzen/educations/CREATE_SUCCESS'

export const FETCH = 'offerzen/educations/FETCH'
export const FETCH_SUCCESS = 'offerzen/educations/FETCH_SUCCESS'

export const UPDATE = 'offerzen/educations/UPDATE'
export const UPDATE_SUCCESS = 'offerzen/educations/UPDATE_SUCCESS'

export const DELETE = 'offerzen/educations/DELETE'
export const DELETE_SUCCESS = 'offerzen/educations/DELETE_SUCCESS'

export const TOGGLE_EDIT = 'offerzen/educations/TOGGLE_EDIT'

export const SET_EDUCATION_ITEM_TO_DELETE = 'offerzen/educations/SET_EDUCATION_ITEM_TO_DELETE'

export const SEARCH_UNIVERSITIES = 'offerzen/educations/SEARCH_UNIVERSITIES'
export const SEARCH_UNIVERSITIES_SUCCESS = 'offerzen/educations/SEARCH_UNIVERSITIES_SUCCESS'
export const SEARCH_UNIVERSITIES_ERROR = 'offerzen/educations/SEARCH_UNIVERSITIES_ERROR'

export const SEARCH_DEGREES = 'offerzen/educations/SEARCH_DEGREES'
export const SEARCH_DEGREES_SUCCESS = 'offerzen/educations/SEARCH_DEGREES_SUCCESS'
export const SEARCH_DEGREES_ERROR = 'offerzen/educations/SEARCH_DEGREES_ERROR'

export const ADD_TEMP_ITEM = 'offerzen/educations/ADD_TEMP_ITEM'
export const DELETE_TEMP_ITEM = 'offerzen/educations/DELETE_TEMP_ITEM'

// ACTION CREATORS
export const createEducation = (id, data) => ({
  type: CREATE,
  payload: { id, data },
})

export const createEducationSuccess = data => ({
  type: CREATE_SUCCESS,
  payload: { ...data },
})

export const fetchEducations = id => ({
  type: FETCH,
  payload: { id },
})

export const fetchEducationSuccess = data => ({
  type: FETCH_SUCCESS,
  payload: [...data],
})

export const updateEducation = (id, data, candidate_id, resolve, reject) => ({
  type: UPDATE,
  payload: { id, data, candidate_id },
  meta: { resolve, reject },
})

export const updateEducationSuccess = data => ({
  type: UPDATE_SUCCESS,
  payload: { ...data, loading: false },
})

export const deleteEducation = (id, candidate_id) => ({
  type: DELETE,
  payload: { id, candidate_id },
})

export const toggleEditing = (id, editing) => ({
  type: TOGGLE_EDIT,
  payload: { id, editing },
})

export const deleteEducationSuccess = id => ({
  type: DELETE_SUCCESS,
  payload: { id },
})

export const setEducationItemToDelete = educationItemToDelete => ({
  type: SET_EDUCATION_ITEM_TO_DELETE,
  payload: { educationItemToDelete },
})

export const searchUniversities = (id, term) => ({
  type: SEARCH_UNIVERSITIES,
  meta: { term },
  payload: {
    id,
    searchingUniversities: true,
    universitiesSearchError: null,
  },
})

export const searchUniversitiesSuccess = (id, data) => ({
  type: SEARCH_UNIVERSITIES_SUCCESS,
  payload: {
    id,
    universitiesSearchResults: data,
    searchingUniversities: false,
  },
})

export const searchUniversitiesError = errorMessage => ({
  type: SEARCH_UNIVERSITIES_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const searchDegrees = (id, term) => ({
  type: SEARCH_DEGREES,
  meta: { term },
  payload: {
    id,
    searchingDegrees: true,
    degreesSearchError: null,
  },
})

export const searchDegreesSuccess = (id, data) => ({
  type: SEARCH_DEGREES_SUCCESS,
  payload: {
    id,
    degreesSearchResults: data,
    searchingDegrees: false,
  },
})

export const searchDegreesError = errorMessage => ({
  type: SEARCH_DEGREES_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

/*
 ** `tempId` is used as a unique identifier for new instances of EditEducationForm,
 ** only records that have not been persisted to the database will use `tempId`, those
 ** that have will use an `id` instead
 */
export const addBlankEducationItem = tempId => ({
  type: ADD_TEMP_ITEM,
  payload: {
    tempId,
    fetched: false,
    editing: true,
  },
})

export const deleteBlankEducationItem = tempId => ({
  type: DELETE_TEMP_ITEM,
  payload: { tempId },
})

// REDUCERS
const initialState = {
  loading: false,
  editing: false,
  fetched: true,

  universitiesSearchResults: [],
  searchingUniversities: false,
  universitiesSearchError: null,

  degreesSearchResults: [],
  searchingDegrees: false,
  degreesSearchError: null,
}

const education = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TEMP_ITEM:
    case CREATE_SUCCESS:
      return {
        ...state,
        ...action.payload,
      }

    case TOGGLE_EDIT:
    case UPDATE_SUCCESS:
      if (state.id !== action.payload.id) return state

      return {
        ...state,
        ...action.payload,
      }

    case SEARCH_UNIVERSITIES:
    case SEARCH_UNIVERSITIES_SUCCESS:
    case SEARCH_DEGREES:
    case SEARCH_DEGREES_SUCCESS: {
      if (state.id !== action.payload.id) return state

      const { id, ...payload } = action.payload
      return {
        ...state,
        ...payload,
      }
    }

    case SEARCH_UNIVERSITIES_ERROR:
      return {
        ...state,
        searchingUniversities: false,
        universitiesSearchError: action.payload,
      }

    case SEARCH_DEGREES_ERROR:
      return {
        ...state,
        searchingDegrees: false,
        degreesSearchError: action.payload,
      }

    default:
      return {
        ...initialState,
        ...state,
      }
  }
}

const educationItemToDelete = (state = {}, action) => {
  switch (action.type) {
    case SET_EDUCATION_ITEM_TO_DELETE:
      return {
        ...state,
        ...action.payload.educationItemToDelete,
      }

    default:
      return state
  }
}

const defaultEducation = []

const entities = (state = defaultEducation, action) => {
  switch (action.type) {
    case CREATE_SUCCESS:
    case ADD_TEMP_ITEM:
      return [...state, education(undefined, action)]

    case DELETE_TEMP_ITEM:
      return [...state.filter(item => item.tempId !== action.payload.tempId)]

    case DELETE_SUCCESS:
      return [...state.filter(item => item.id !== action.payload.id)]

    case FETCH_SUCCESS:
      return [...action.payload.map(item => education(item, action))]

    case TOGGLE_EDIT:
    case UPDATE_SUCCESS:
    case SEARCH_UNIVERSITIES:
    case SEARCH_UNIVERSITIES_SUCCESS:
    case SEARCH_UNIVERSITIES_ERROR:
    case SEARCH_DEGREES:
    case SEARCH_DEGREES_SUCCESS:
    case SEARCH_DEGREES_ERROR:
      return state.map(item => education(item, action))

    default:
      return state
  }
}

const educationsReducer = combineReducers({
  entities,
  educationItemToDelete,
})

export default educationsReducer

export const getEducation = state => state.views.profile.educations.entities || defaultEducation
